/* eslint-disable vue/require-v-for-key */
<template>
  <v-card>
    <v-form ref="form" v-model="isFormValid" lazy-validation>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-text-field
                v-model="selectedItem.nameRegistration"
                label="Nome do Documento"
                required
                :rules="formRules.nameRules"
                hide-details="auto"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-select
                v-model="selectedItem.activeId"
                :items="actives"
                item-text="name_token"
                item-value="id"
                label="Ativos"
                return-object
                single-line
                v-on:change="changeLotes(selectedItem.activeId)"
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-text-field
                label="Unidade de medida do ativo"
                disabled
                hide-details="auto"
                :value="selectedItem.valorunidade + ' ' + selectedItem.unidades"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6" sm="6" md="6">
              <v-text-field
                label="Quantidade de token a serem geradas"
                hide-details="auto"
                v-model="selectedItem.QtdVolume"
              ></v-text-field>
            </v-col>
            <v-col cols="6" sm="6" md="6">
              <v-text-field
                label="Quantidade x Valor Unitário"
                disabled
                hide-details="auto"
                :value="(selectedItem.QtdVolume * selectedItem.singleValue).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })"
              ></v-text-field>
            </v-col>
          </v-row>
          <!-- <v-row>
            <v-select
              v-model="selectedItem.lotes"
              :items="lotes"
              item-text="lote"
              item-value="id"
              label="Lotes"
              v-on:change="changeTokens(selectedItem.lotes)"
            ></v-select>
          </v-row>
          <v-row>
            <v-expansion-panels accordion>
              <v-expansion-panel>
                <v-expansion-panel-header
                  >Tokens ({{ tokens.length }})</v-expansion-panel-header
                >
                <v-expansion-panel-content>
                  <ul id="tokens">
                    <li v-for="token in tokens" :key="token">
                      {{ token }}
                    </li>
                  </ul>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-row> -->
          <!-- <v-row>
            <v-col cols="6" sm="6" md="6">
              <v-text-field
                v-model="selectedItem.token_initial_1"
                label="Token Inicial 1"
                required
                :rules="formRules.initialRules1"
                hide-details="auto"
              ></v-text-field>
            </v-col>
            <v-col cols="6" sm="6" md="6">
              <v-text-field
                v-model="selectedItem.token_final_1"
                label="Token Final 1"
                :rules="formRules.finalRules1"
                required
                hide-details="auto"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6" sm="6" md="6">
              <v-text-field
                v-model="selectedItem.token_initial_2"
                label="Token Inicial 2"
                required
                :rules="formRules.initialRules2"
                hide-details="auto"
              ></v-text-field>
            </v-col>
            <v-col cols="6" sm="6" md="6">
              <v-text-field
                v-model="selectedItem.token_final_2"
                label="Token Final 2"
                :rules="formRules.finalRules2"
                required
                hide-details="auto"
              ></v-text-field>
            </v-col>
          </v-row> -->

          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-file-input
                v-model="selectedItem.filesRegistration"
                hide-details="auto"
                label="Documentos (matrículas, etc.)"
                prepend-icon="mdi-file-upload"
                multiple
                :rules="formRules.registrationRules"
                show-size
                counter
                small-chips
                truncate-length="25"
              ></v-file-input>
            </v-col>

            <v-col cols="12" sm="12" md="12">
              <table
                v-for="(file, index) in filesRegistrations"
                :key="file.id"
                :style="{ marginBottom: '20px' }"
              >
                <tr>
                  <th>Visualizar</th>
                  <th>Excluir</th>
                </tr>
                <tr>
                  <td
                    :style="{ width: '206px !important', textAlign: 'center' }"
                  >
                    <a
                      :href="
                        'https://filesgpx.s3.us-east-2.amazonaws.com/' +
                        file.path
                      "
                      download
                      target="_blank"
                    >
                      {{ file.name }}
                    </a>
                  </td>
                  <td>
                    <v-row
                      align="center"
                      justify="center"
                      :style="{ cursor: 'pointer' }"
                      @click="deleteFileRegistration(index, file.path)"
                    >
                      <v-icon color="red"> mdi-delete </v-icon>
                    </v-row>
                  </td>
                </tr>
              </table>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-file-input
                v-model="selectedItem.filesGeoreferences"
                hide-details="auto"
                label="Imagem georeferência da matrícula"
                prepend-icon="mdi-file-upload"
                multiple
                :rules="formRules.areaRules"
                show-size
                counter
                small-chips
                truncate-length="25"
              ></v-file-input>
            </v-col>

            <v-col cols="12" sm="12" md="12">
              <table
                v-for="(file, index) in filesGeoreferences"
                :key="file.id"
                :style="{ marginBottom: '20px' }"
              >
                <tr>
                  <th>Visualizar</th>
                  <th>Excluir</th>
                </tr>
                <tr>
                  <td
                    :style="{ width: '206px !important', textAlign: 'center' }"
                  >
                    <a
                      :href="
                        'https://filesgpx.s3.us-east-2.amazonaws.com/' +
                        file.path
                      "
                      download
                      target="_blank"
                    >
                      {{ file.name }}
                    </a>
                  </td>
                  <td>
                    <v-row
                      align="center"
                      justify="center"
                      :style="{ cursor: 'pointer' }"
                      @click="deleteFileGeoreference(index, file.path)"
                    >
                      <v-icon color="red"> mdi-delete </v-icon>
                    </v-row>
                  </td>
                </tr>
              </table>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-file-input
                v-model="selectedItem.filesArea"
                hide-details="auto"
                label="Documentos de Contrato da Área"
                prepend-icon="mdi-file-upload"
                multiple
                show-size
                :rules="formRules.areaRules"
                counter
                small-chips
                truncate-length="25"
              ></v-file-input>
            </v-col>

            <v-col cols="12" sm="12" md="12">
              <table
                v-for="(file, index) in filesAreas"
                :key="file.id"
                :style="{ marginBottom: '20px' }"
              >
                <tr>
                  <th>Visualizar</th>
                  <th>Excluir</th>
                </tr>
                <tr>
                  <td
                    :style="{ width: '206px !important', textAlign: 'center' }"
                  >
                    <a
                      :href="
                        'https://filesgpx.s3.us-east-2.amazonaws.com/' +
                        file.path
                      "
                      download
                      target="_blank"
                    >
                      {{ file.name }}
                    </a>
                  </td>
                  <td>
                    <v-row
                      align="center"
                      justify="center"
                      :style="{ cursor: 'pointer' }"
                      @click="deleteFileArea(index, file.path)"
                    >
                      <v-icon color="red"> mdi-delete </v-icon>
                    </v-row>
                  </td>
                </tr>
              </table>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="#0dc4b8" text @click="$emit('onClose');"> Cancelar </v-btn>
        <v-btn
          color="#0dc4b8"
          text
          @click="submit"
          :disabled="isLoading"
          :loading="isLoading"
        >
          {{ formButtonText }}
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>


<script>
import { mapMutations } from "vuex";
//import RegistrationService from "../../services/registrationArea.service";
import Api from "../../services/api.service";

export default {
  name: "RegistrationForm",
  props: {
    selectedIndex: {
      type: Number,
      required: false,
      default: -1,
    },
    selectedData: Array,
    filesRegistrationsProps: Array,
    filesGeoreferencesProps: Array,
    filesAreasProps: Array,
    selectedActive: Array,
  },
  data: (route) => ({
    filesRegistrations: [],
    tokens: [],
    tokensGeral: [],
    actives: [],
    lotes: [],
    formRules: {
      nameRules: [(v) => !!v || "Documento é obrigatório"],
      loteRules: [(v) => !!v || "Lote é obrigatório"],
      initialRules1: [(v) => !!v || "Token Inicial é obrigatório"],
      finalRules1: [(v) => !!v || "Token Final é obrigatório"],
      initialRules2: [(v) => !!v || "Token Inicial é obrigatório"],
      finalRules2: [(v) => !!v || "Token Final é obrigatório"],
      registrationRules: [
        (v) =>
          !!v || v.size < 2000000 || "Documento deve ser menor do que 2 MB!",
      ],
      areaRules: [
        (v) => !!v || v.size < 2000000 || "Foto deve ser menor do que 2 MB!",
      ],
    },
    isFormValid: true,
    isLoading: false,
    selectedItem: {
      nameRegistration: null,
      lotes: null,
      activeId: {},
      singleValue: 1,
      unidades: "Ton",
      token_initial_1: null,
      token_final_1: null,
      token_initial_2: null,
      token_final_2: null,
      filesRegistration: [],
      filesGeoreference: [],
      filesArea: [],
      QtdVolume: 0,
      valorunidade: null,
    },
    filesGeoreferences: [],
    filesAreas: [],
    filesDeleteRegistration: [],
    filesDeleteArea: [],
    item: route,
  }),
  computed: {
    formButtonText() {
      return this.selectedIndex === -1 ? "Criar" : "Editar";
    },
  },
  mounted() {
    this.loadCreated();

   
    if (this.selectedIndex !== -1) this.changeLotes(this.selectedActive);

    if (this.selectedIndex !== -1) {
      Api.get(`registration/${this.selectedIndex}`)
        .then((res) => {
          this.filesRegistrationsProps = res.data.files_registration;
          this.filesGeoreferencesProps = res.data.files_georeference;
          this.filesAreasProps = res.data.files_area;
        })
        .then(() => {
          var filesRegistration = [];
          var filesGeoreference = [];
          var filesArea = [];

          if (this.filesRegistrationsProps) {
            this.filesRegistrationsProps.map((item) => {
              filesRegistration.push(
                new File(
                  ["https://filesgpx.s3.us-east-2.amazonaws.com/" + item.path],
                  item.name,
                  {
                    type: item.mime_type,
                  }
                )
              );
            });

            this.selectedItem.filesRegistration = [];

            this.filesRegistrations = this.filesRegistrationsProps;
          }

          if (this.filesGeoreferencesProps) {
            this.filesGeoreferencesProps.map((item) => {
              filesGeoreference.push(
                new File(
                  ["https://filesgpx.s3.us-east-2.amazonaws.com/" + item.path],
                  item.name,
                  {
                    type: item.mime_type,
                  }
                )
              );
            });

            this.selectedItem.filesGeoreferences = [];

            this.filesGeoreferences = this.filesGeoreferencesProps;
          }
          if (this.filesAreasProps) {
            this.filesAreasProps.map((item) => {
              filesArea.push(
                new File(
                  ["https://filesgpx.s3.us-east-2.amazonaws.com/" + item.path],
                  item.name,
                  {
                    type: item.mime_type,
                  }
                )
              );
            });

            this.selectedItem.filesArea = [];

            this.filesAreas = this.filesAreasProps;
          }
        });
      setTimeout(() => {
        this.selectedItem.nameRegistration =
          this.selectedData.name_registration;
        this.selectedItem.lotes = this.selectedData.lote;
        this.selectedItem.activeId = this.selectedActive;
        this.selectedItem.QtdVolume = this.selectedData.qtdvolume;
        this.selectedItem.valorunidade = this.selectedData.valorunidade;
        Api.get("actives/"+this.selectedItem.activeId.id).then(res =>{
          this.changeLotes(res.data.actives[0])
        })
      }, 10);
    }
  },
  methods: {
    ...mapMutations(["showSnackbar"]),

    openDialog() {
      this.dialog = true;
    },

    closeDialog() {
      // this.closeFormModal();

      this.selectedItem.nameRegistration = null;
      this.selectedItem.activeId = null;
      this.selectedItem.lotes = null;
      this.selectedItem.token_initial_1 = null;
      this.selectedItem.token_final_1 = null;
      this.selectedItem.token_initial_2 = null;
      this.selectedItem.token_final_2 = null;
      this.selectedItem.filesRegistration = [];
      this.selectedItem.filesGeoreferences = [];
      this.selectedItem.filesArea = [];
      this.selectedItem.unidades = null;
      this.selectedItem.valorunidade = null;
      this.selectedItem.singleValue = 1;
      this.actives = [];

      this.filesAreas = null;
      this.filesRegistrations = null;
      this.filesGeoreferences = null;
      this.isLoading = false;

      this.$emit("onClose");
    },

    async loadCreated() {
      if (this.item.$route.params.activeId) {
        Api.get("actives/" + this.item.$route.params.activeId.code).then(
          (res) => {
            this.selectedItem.unidades = res.data.actives[0].unidades;
            this.selectedItem.valorunidade = res.data.actives[0].valorunidade;
            this.selectedItem.singleValue = res.data.actives[0].single_value;
            this.selectedItem.lotes = res.data.actives[0].total_lote;
          }
        );
        this.selectedItem.activeId = {
          id: this.item.$route.params.activeId.code,
          name_token: this.item.$route.params.activeId.name_token,
        };
        this.actives.push(this.selectedItem.activeId);
        this.changeLotes(this.selectedItem.activeId);
      } else {
        this.selectedItem.unidades = null;
        this.selectedItem.singleValue = 1;
        this.actives = [];
        Api.get("registration/create").then((res) => {
          var arrayActives = [];

          res.data[0].map((item) => {
            var valid = false;

            arrayActives.map((e) => {
              if (e.name_token == item.name_token) {
                valid = true;
              }
            });

            if (!valid) arrayActives.push(item );
          })
          this.actives = arrayActives;
        });
      }
    },

    deleteFileRegistration(file, path) {
      this.filesDeleteRegistration.push(path);
      this.filesRegistrations.splice(file, 1);
    },
    deleteFileGeoreference(file, path) {
      this.filesDeleteGeoreference.push(path);
      this.filesGeoreferences.splice(file, 1);
    },
    deleteFileArea(file, path) {
      this.filesDeleteArea.push(path);
      this.filesAreas.splice(file, 1);
    },

    changeLotes(obj) {
      this.lotes = [];
      this.selectedItem.singleValue = obj.single_value;
      this.selectedItem.unidades = obj.unidades;
      this.selectedItem.valorunidade = obj.valorunidade;
      this.selectedItem.lotes= obj.total_lote

      Api.get(`generation-tokens/${obj.id}`)
        .then((res) => {
          res.data.lotes.map((item) => {
            this.lotes.push(item.lote);
          });
         // this.selectedItem.lotes = this.lotes[0];
          this.tokensGeral = res.data.tokens;
          this.changeTokens(this.lotes[0]);
        })
        .catch(() => {
          this.showSnackbar({
            text: "Ops!, Houve um erro ao carregar os Lotes, tente novamente mais tarde.",
            color: "error",
          });
        });
    },

    async changeTokens(a) {
      this.tokens = [];
      this.tokensGeral.map((item) => {
        if (item.lote == a) this.tokens.push(item.name);
      });
    },

    async submit() {
      this.isLoading = true;
      if (this.selectedIndex === -1) {
        let data = new FormData();
      
        data.append("nameRegistration", this.selectedItem.nameRegistration);
        data.append("lote", this.selectedItem.lotes);
        data.append("qtdvolume", this.selectedItem.QtdVolume);
        
        data.append("activeId", this.selectedItem.activeId.id);
        for (let i = 0; i < this.selectedItem.filesRegistration.length; i++) {
          data.append(
            "fileRegistration" + [i],
            this.selectedItem.filesRegistration[i]
          );
        }
        data.append(
          "totalFilesRegistration",
          this.selectedItem.filesRegistration.length
        );

        for (let i = 0; i < this.selectedItem.filesGeoreferences.length; i++) {
          data.append(
            "filesGeoreference" + [i],
            this.selectedItem.filesGeoreferences[i]
          );
        }
        data.append(
          "totalFilesGeoreference",
          this.selectedItem.filesGeoreferences.length
        );

        for (let i = 0; i < this.selectedItem.filesArea.length; i++) {
          data.append("fileArea" + [i], this.selectedItem.filesArea[i]);
        }
        data.append("totalFilesArea", this.selectedItem.filesArea.length);

        Api.post("registration", data, {
          header: {
            "Content-Type": "multipart/form-data",
          },
        })
          .then(() => {
            this.showSnackbar({
              text: "Cadastrado! Matrícula cadastrada com sucesso.",
              color: "success",
            });

            this.isLoading = false;
            this.closeDialog();
          })
          .catch(() => {
            this.showSnackbar({
              text: "Ops! Houve um erro, tente novamente.",
              color: "error",
            });

            this.isLoading = false;
          });
      } else {
        let data = new FormData();

        data.append("nameRegistration", this.selectedItem.nameRegistration);
        data.append("lote", this.selectedItem.lotes);
        data.append("activeId", this.selectedItem.activeId.id);
        data.append("qtdvolume", this.selectedItem.QtdVolume);
        for (let i = 0; i < this.selectedItem.filesRegistration.length; i++) {
          data.append(
            "fileRegistration" + [i],
            this.selectedItem.filesRegistration[i]
          );
        }
        data.append(
          "totalFilesRegistration",
          this.selectedItem.filesRegistration.length
        );

        for (let i = 0; i < this.selectedItem.filesGeoreferences.length; i++) {
          data.append(
            "fileGeoreference" + [i],
            this.selectedItem.filesGeoreferences[i]
          );
        }
        data.append(
          "totalFilesGeoreference",
          this.selectedItem.filesGeoreferences.length
        );

        for (let i = 0; i < this.selectedItem.filesArea.length; i++) {
          data.append("fileArea" + [i], this.selectedItem.filesArea[i]);
        }
        data.append("totalFilesArea", this.selectedItem.filesArea.length);

        data.append("filesDeleteRegistration", this.filesDeleteRegistration);
        data.append(
          "totalFilesDeleteRegistration",
          this.filesDeleteRegistration.length
        );

        data.append("filesDeleteArea", this.filesDeleteArea);
        data.append("totalFilesDeleteArea", this.filesDeleteArea.length);

        Api.patch(`registration/${this.selectedIndex}`, data, {
          header: {
            "Content-Type": "multipart/form-data",
          },
        })
          .then(() => {
            this.showSnackbar({
              text: "Cadastrado! Matrícula cadastrada com sucesso.",
              color: "success",
            });

            this.isLoading = false;
            this.closeDialog();
          })
          .catch(() => {
            this.filesAreas.map((item) => {
              this.selectedItem.filesArea.map((files, index) => {
                if (files.name === item.name) {
                  this.selectedItem.filesArea.splice(index, 1);
                }
              });
            });

            this.filesRegistrations.map((item) => {
              this.selectedItem.filesRegistration.map((files, index) => {
                if (files.name === item.name) {
                  this.selectedItem.filesRegistration.splice(index, 1);
                }
              });
            });

            this.filesGeoreferences.map((item) => {
              this.selectedItem.filesGeoreferences.map((files, index) => {
                if (files.names === item.name) {
                  this.selectedItem.filesGeoreferences.splice(index, 1);
                }
              });
            });

            this.showSnackbar({
              text: "Ops! Houve um erro, tente novamente.",
              color: "error",
            });

            this.isLoading = false;
          });
      }
    },
  },
};
</script>
<style>
#tokens {
  padding: 0;
  margin: 0;
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: left;
  gap: 7px;
}
#tokens li {
  text-align: center;
  min-width: 30px;
  list-style: none;
  border: 1px solid #ccc;
  border-radius: 3px;
  padding: 3px;
}
</style>
